module.exports = __webpack_public_path__ + "img/tianshu.e627249e.png";